import { render, staticRenderFns } from "./wait-for-confirmation.vue?vue&type=template&id=c4bdb502&scoped=true&"
import script from "./wait-for-confirmation.vue?vue&type=script&lang=js&"
export * from "./wait-for-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./wait-for-confirmation.vue?vue&type=style&index=0&id=c4bdb502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bdb502",
  null
  
)

export default component.exports